import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const NUMBERS = [
  { label: "+234 812 480 1607", wa: "2348124801607" },
  { label: "+234 810 777 8448", wa: "2348107778448" },
];

const WA_TEXT = encodeURIComponent("Hello Motaps Global, I would like to make an enquiry.");

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-float">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="bg-[#1C2541] border border-slate-700/60 rounded-2xl p-4 shadow-2xl w-64 backdrop-blur-md"
            data-testid="whatsapp-panel"
          >
            <p className="text-xs font-display font-semibold tracking-widest uppercase text-slate-400 mb-3">Chat with us on WhatsApp</p>
            <div className="space-y-2">
              {NUMBERS.map(({ label, wa }) => (
                <a
                  key={wa}
                  href={`https://wa.me/${wa}?text=${WA_TEXT}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`whatsapp-link-${wa}`}
                  className="flex items-center gap-3 bg-[#0B132B] border border-slate-700/50 rounded-xl px-4 py-3 text-sm font-semibold text-slate-200 hover:border-[#25D366]/60 hover:text-[#25D366] transition-colors duration-200"
                >
                  <span className="text-[#25D366]"><WhatsAppIcon /></span> {label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        onClick={() => setOpen((o) => !o)}
        data-testid="whatsapp-toggle-button"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)]"
      >
        {open ? <X size={24} /> : <WhatsAppIcon />}
      </motion.button>
    </div>
  );
}
